module.exports = __webpack_public_path__ + "assets/advantages-benefits-f0dc2a.svg";